import { AccountRow } from "./types";
import { AccountMappingStatus } from "./AccountMappingStatus";
import styles from "./MapImportedAccountsSpreadsheet.module.scss";
import { AccountMappingAction } from "./AccountsMappingAction";

interface Props {
    row: AccountRow;
    isAccountsMappingActive?: boolean;
    onCreateNewAccount?: (row: AccountRow) => void;
    onUndoCreateNewAccount?: (importedAccountId: string) => void;
    onUndoMapping?: (importedAccountId: string) => void;
    onMarkAsFinancial?: (row: AccountRow) => void;
    onUnmarkAsFinancial?: (importedAccountId: string) => void;
}

export const AccountMappingActionCell: React.FC<Props> = ({
    row,
    isAccountsMappingActive,
    onCreateNewAccount,
    onUndoCreateNewAccount,
    onUndoMapping,
    onMarkAsFinancial,
    onUnmarkAsFinancial,
}) => (
    <div className={styles.actionCellRow}>
        <AccountMappingStatus row={row} />
        {!isAccountsMappingActive && (
            <AccountMappingAction
                row={row}
                onCreateNewAccount={onCreateNewAccount}
                onUndoCreateNewAccount={onUndoCreateNewAccount}
                onUndoMapping={onUndoMapping}
                onMarkAsFinancial={onMarkAsFinancial}
                onUnmarkAsFinancial={onUnmarkAsFinancial}
            />
        )}
    </div>
);
